import canUse from './canUse'

const DeleteUser = () => canUse() && localStorage.removeItem('USER')

export default DeleteUser
